export default {
  FILE_SELECTION: 'FILE_SELECTION',
  UPLOAD_IN_PROGRESS: 'UPLOAD_IN_PROGRESS',
};
